module.exports = __webpack_public_path__ + "img/dropdown.9bc4ff3a.svg";